<template>
  <TrainerLayout>
    <section class="my-10 mb-4">
      <div class="mb-4">
        <div class="hidden">
          <label for="tabs" class="sr-only">Select a tab</label>
          <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
          <select
            id="tabs"
            name="tabs"
            class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-green-light focus:border-green-light sm:text-sm rounded-md"
          >
            <option>Explore Music</option>

            <option selected>View Playlist</option>
          </select>
        </div>
        <div class="">
          <div class=" flex px-1 justify-between flex-col md:flex-row">
            <nav class="border-b border-gray-200 -mb-px flex md:space-x-8 space-x-4" aria-label="Tabs">
              <!-- Default: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" -->
              <router-link
                :to="{ name: 'music' }"
                class="border-green-dark text-gray-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                :class="{ current: 'border-gray-dark text-gray-dark' }"
              >
                Explore Music
              </router-link>

              <router-link
                :to="{ name: 'playlist' }"
                class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
              >
                View Playlist
              </router-link>
              <router-link
                :to="{ name: 'favorite' }"
                class="border-transparent text-gray-500 hover:text-gray-dark hover:border-green-dark whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
              >
                Favorite
              </router-link>
            </nav>
            <router-link
              :to="{
                name: 'music',
                params: { cat: 'All Music' },
              }"
              class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
              v-if="this.$route.params && this.$route.params.cat != 'All Music'"
            >
            <span class="px-1 whitespace-nowrap">See all</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
            </router-link>
          </div>
        </div>
      </div>

      <section v-if="this.$route.params && this.$route.params.cat">
        <div class="">
          <div class="flex justify-between flex-col sm:flex-row">
            <div class="flex items-center">
              <button type="button" @click="$router.go(-1)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
              <div class="sm:flex-auto ml-2">
                <h1 class="text-xl font-semibold text-gray-900">
                  {{ this.$route.params && this.$route.params.cat }}
                </h1>
              </div>
            </div>
            <div class="flex flex-1 sm:justify-end mt-4 sm:mt-0">
              <div class="mt-1 relative sm:ml-4 mr-4 h-full">
                <input
                  type="search"
                  name="account-number"
                  id="account-number"
                  class="block w-full pl-14 pr-10 sm:text-sm border-gray-300 rounded-3xl focus:ring-gray-darker ring-1 ring-gray-darkest h-11 focus:outline-none"
                  placeholder="Song, Artist, Mood, etc."
                  v-model="search"
                  v-on:input="oninputSearch"
                />
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-light"
                >
                  <!-- Heroicon name: solid/question-mark-circle -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="1"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>
              <button
                class="inline-flex items-center h-10 px-5 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-green-light hover:bg-white hover:text-green-light space-x-1 m-1 mr-0"
                @click="toggleFilterModal"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                  />
                </svg>
                <span>Filter</span>
              </button>
            </div>
          </div>

          <Modal
            :title="'Filters'"
            :headerClass="'text-xl pt-1'"
            v-model="isMenuOpen"
            :classStr="'max-w-lg'"
            class="modal"
            :whiteCross="'text-white text-4xl'"
          >
            <hr class="text-gray-400 py-2" />
            <div class="overflow-auto" style="height: 70vh">
              <div class="flex justify-between">
                <p class="black text-md mb-2 tracking-wider">Energy</p>
              </div>
              <label class="text-gray-light mb-4 text-sm">
                <!-- filter[energy] -->
                <input
                  type="range"
                  class="w-full max-w-md accent-pink-500 slider mb-5"
                  min="1"
                  max="4"
                  v-model="energy"
                />
                <!-- <MultiRangeSlider
                  :min="1"
                  :max="4"
                  :ruler="false"
                  :label="false"
                  :minCaption="'' + energyMinValue"
                  :maxCaption="'' + energyMaxValue"
                  :baseClassName="'multi-range-slider max-w-md'"
                  :minValue="energyMinValue"
                  :maxValue="energyMaxValue"
                  @input="UpdateEnergyValues"
                /> -->
                <div class="grid md:grid-cols-4 grid-cols-2 gap-2 mb-8">
                  <span class="ml-1">Very Low</span>
                  <span class="ml-4">Low</span>
                  <span class="ml-6">Medium</span>
                  <span class="pl-12">High</span>
                </div>
              </label>

              <hr class="text-gray-400 py-2" />
              <div class="flex justify-between">
                <p class="text-black text-md mb-2 tracking-wider">Genre</p>
              </div>
              <div
                class="mb-2 p-1 max-w-md"
                :class="
                  showMoreGenre === false
                    ? 'h-24 overflow-hidden grid md:grid-cols-3 gap-2'
                    : 'grid md:grid-cols-2 gap-4'
                "
              >
                <!-- <label
                  class="text-gray-700 mb-4 text-sm"
                  v-for="g in genre"
                  :key="g.id"
                >
                  filter[tags][genre]
                  <input type="checkbox" name="genre" :value="g && g.id" />
                  <span class="ml-1">
                    {{ g && g.attributes && g.attributes.name }}
                  </span>
                </label> -->
                <button
                  class="items-center h-10 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="s in selectedGenre"
                  :key="s.id"
                  @click="onclickGenre(s)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{
                      s && s.attributes && s.attributes.name
                    }}</span>
                    <X />
                  </div>
                </button>
                <button
                  class="items-center h-10 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="g in genre"
                  :key="g.id"
                  @click="onclickGenre(g)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">
                      {{ g && g.attributes && g.attributes.name }}
                    </span>
                    <Plus />
                  </div>
                </button>
              </div>
              <button
                class="underline focus:outline-none italic text-sm pb-2"
                @click="showMoreGenre = !showMoreGenre"
              >
                Show {{ showMoreGenre ? "less" : "more" }}
              </button>
              <hr class="text-gray-400 py-2" />

              <div class="flex justify-between">
                <p class="text-black text-md mb-2 tracking-wider">
                  Vocals/Instrumental
                </p>
              </div>
              <div class="grid md:grid-cols-3 grid-cols-2 gap-4 mb-8 mx-1">
                <button
                  class="flex flex-col items-center h-32 px-5 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  @click="vocals = 'All'"
                  :class="{ 'bg-green-light text-yellow-100': vocals == 'All' }"
                >
                  <label class="text-gray-700 cursor-pointer">
                    <input
                      type="radio"
                      value=""
                      name="vocals"
                      class="invisible"
                    />
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 65 65"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M53.558 5.505h-32c-2.934 0-5.334 2.4-5.334 5.333v32c0 2.934 2.4 5.334 5.334 5.334h32c2.933 0 5.333-2.4 5.333-5.333v-32c0-2.934-2.4-5.334-5.333-5.334zm0 37.334h-32v-32h32v32zm-20-2.667a6.667 6.667 0 0 0 6.666-6.667V18.838h8v-5.333H37.558v14.693a6.525 6.525 0 0 0-4-1.36 6.666 6.666 0 1 0 0 13.334zm-22.667-24H5.558v37.333c0 2.933 2.4 5.334 5.333 5.334h37.333v-5.334H10.891V16.172z"
                        fill="#364B69"
                      />
                    </svg>
                    <span>All</span>
                  </label>
                </button>
                <!-- filter[vocals] -->
                <button
                  class="flex flex-col items-center h-32 px-5 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  @click="vocals = 'vocals'"
                  :class="{
                    'bg-green-light text-yellow-100': vocals == 'vocals',
                  }"
                >
                  <label class="text-gray-700 cursor-pointer">
                    <input
                      type="radio"
                      value="vocals"
                      name="vocals"
                      class="invisible"
                    />
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 65 65"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#wm5kp26m8a)">
                        <path
                          d="M29.333 10.667a10.667 10.667 0 1 1 0 21.334 10.667 10.667 0 0 1 0-21.334zm0 5.333a5.333 5.333 0 1 0 0 10.667 5.333 5.333 0 0 0 0-10.667zm0 18.667c2.934 0 7.094.613 10.96 1.84-1.626 1.013-2.96 2.426-4 4.106-2.186-.533-4.586-.88-6.96-.88-7.92 0-16.266 3.894-16.266 5.6v2.934h21.706c.24 1.866.907 3.573 1.92 5.066H8v-8c0-7.093 14.213-10.666 21.333-10.666zm20-8h9.334V32h-5.334v14.667A6.666 6.666 0 1 1 46.667 40c.96 0 1.84.187 2.666.56V26.667z"
                          fill="#364B69"
                        />
                      </g>
                      <defs>
                        <clipPath id="wm5kp26m8a">
                          <path
                            fill="#fff"
                            transform="translate(.156 .173)"
                            d="M0 0h64v64H0z"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Vocals</span>
                  </label>
                </button>
                <!-- filter[instrumental] -->
                <button
                  class="flex flex-col items-center h-32 px-5 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  @click="vocals = 'Instrumental'"
                  :class="{
                    'bg-green-light text-yellow-100': vocals == 'Instrumental',
                  }"
                >
                  <label class="text-gray-700 cursor-pointer">
                    <input
                      type="radio"
                      value="instrumental"
                      name="vocals"
                      class="invisible"
                    />
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 54 51"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="ml-5"
                    >
                      <path
                        d="M1.756 49.173h6.667M1.756 41.173h6.667M1.756 33.173h6.667M1.756 25.173h6.667M16.423 49.173h6.667M16.423 41.173h6.667M16.423 33.173h6.667M16.423 25.173h6.667M16.423 17.173h6.667M16.423 9.173h6.667M16.423 1.173h6.667M31.089 49.173h6.666M45.756 49.173h6.666M31.089 41.173h6.666M45.756 41.173h6.666M31.089 33.173h6.666M45.756 33.173h6.666M45.756 25.173h6.666M45.756 17.173h6.666"
                        stroke="#364B69"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>Instrumental</span>
                  </label>
                </button>
              </div>

              <hr class="text-gray-400 py-2" />

              <div class="flex justify-between">
                <p class="text-black text-md mb-2 tracking-wider">Mood</p>
              </div>
              <div
                class="grid md:grid-cols-3 grid-cols-2 gap-2 mb-2 p-1 max-w-md"
                :class="showMoreMood === false ? 'h-24 overflow-hidden' : ''"
              >
                <!-- <label
                  class="text-gray-700 mb-4 text-sm"
                  v-for="m in mood"
                  :key="m.id"
                >
                  filter[tags][mood]
                  <input type="checkbox" name="mood" :value="m && m.id" />
                  <span class="ml-1">
                    {{ m && m.attributes && m.attributes.name }}
                  </span>
                </label> -->
                <button
                  class="items-center h-10 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="s in selectedMood"
                  :key="s.id"
                  @click="onclickMood(s)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{
                      s && s.attributes && s.attributes.name
                    }}</span>
                    <X />
                  </div>
                </button>
                <button
                  class="items-center h-10 text-gray-light transition-colors duration-150 bg-white hover:text-white hover:bg-green-light focus:bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm focus:text-white"
                  v-for="m in mood"
                  :key="m.id"
                  @click="onclickMood(m)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-1">
                      {{ m && m.attributes && m.attributes.name }}
                    </span>
                    <Plus class="rotate-45" />
                  </div>
                </button>
              </div>
              <button
                class="underline focus:outline-none italic text-sm pb-2"
                @click="showMoreMood = !showMoreMood"
              >
                Show {{ showMoreMood ? "less" : "more" }}
              </button>

              <hr class="text-gray-400 py-2" />

              <div class="flex justify-between">
                <p class="text-black text-md mb-2 tracking-wider">BPM</p>
              </div>
              <label class="text-gray-light mb-8 text-sm px-2">
                <!-- filter[bpm][max] -->
                <!-- <input
                  type="range"
                  class="w-full max-w-md accent-pink-500 slider mb-4"
                  min="1"
                  max="3"
                  v-model="bpm"
                /> -->
                <MultiRangeSlider
                  :min="0"
                  :max="300"
                  :ruler="false"
                  :label="false"
                  :minCaption="'' + bpmMinValue"
                  :maxCaption="'' + bpmMaxValue"
                  :baseClassName="'multi-range-slider max-w-md'"
                  :minValue="bpmMinValue"
                  :maxValue="bpmMaxValue"
                  @input="UpdateBpmValues"
                />
                <div class="grid md:grid-cols-3 grid-cols-2 gap-24 mb-8 px-1">
                  <span class="ml-3">0</span>
                  <span class="ml-6">150</span>
                  <span class="pl-12">300</span>
                </div>
              </label>
            </div>
            <hr class="text-gray-400 py-2" />

            <div class="flex items-center justify-between">
              <button
                type="button"
                class="h-10 px-4 m-2 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:outline-none"
                @click="onclickClear"
              >
                Clear All
              </button>
              <button
                type="button"
                class="h-10 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none"
                @click="onclickApply"
              >
                Apply Filter(s)
              </button>
            </div>
          </Modal>

          <Modal
            :title="'Selected song'"
            v-model="isPlaylistOpen"
            :classStr="'max-w-lg'"
          >
            <div class="flex items-center mb-4 gap-4">
              <div
                class="h-24 w-30 flex-shrink-0 flex relative justify-center items-center"
              >
                <img
                  class="rounded-md"
                  :src="songImage"
                  alt=""
                  @error="defaultImage"
                />
              </div>
              <div class="flex flex-col">
                <span>{{songName}}</span>
                <span class="text-sm">{{songArtist}}</span>
              </div>
            </div>
            <hr class="text-gray-400 py-2" />
            <div class="mb-4 h-80 overflow-auto">
              <div class="mb-4 text-xl">Select playlist</div>
              <button
                v-for="(t, index) in trainerPlaylist"
                :key="t.id"
                @click="playlistSong = t.id"
                class="block ring-green-light focus:outline-none focus:ring-1 focus:ring-green-light rounded-lg p-2 m-1"
                :class="index === trainerPlaylist.length - 1 ? '' : 'mb-3'"
              >
                <div class="flex items-center">
                  <div>
                    <img
                      class="inline-block h-16 w-16 rounded-md"
                      :src="t.thumbnail_url"
                      alt=""
                      @error="defaultImage"
                    />
                  </div>
                  <div class="ml-3 text-left">
                    <p
                      class="text-md font-medium text-gray-700 group-hover:text-gray-900 capitalize"
                    >
                      {{ t.name }}
                    </p>
                    <p
                      class="text-sm font-medium text-gray-500 group-hover:text-gray-700"
                    >
                      {{ String(t.count).trim() }} tracks
                    </p>
                  </div>
                </div>
              </button>
            </div>
            <div class="flex items-center text-center justify-end">
              <button
                class="w-full h-10 px-6 py-2 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:bg-green-light"
                @click="onClickPlaylist(playlistSong)"
              >
                Add to Playlist
              </button>
            </div>
          </Modal>

          <div class="mt-8 flex flex-col">
            <div class="overflow-x-auto">
              <div
                class="inline-block min-w-full align-middle"
              >
                <div
                  class="overflow-hidden shadow ring-1 ring-white ring-opacity-5 md:rounded-lg"
                >
                  <table class="min-w-full divide-y divide-gray-300">
                    <thead class="bg-gray-50">
                      <tr>
                        <th></th>
                        <th
                          scope="col"
                          class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                        >
                          Title
                        </th>
                        <th></th>
                        <th
                          scope="col"
                          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Duration
                        </th>
                        <th
                          scope="col"
                          class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          Mood
                        </th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody
                      class="divide-y divide-gray-200 bg-white"
                      v-if="songs && songs.data"
                    >
                      <tr v-for="(d, i) in songs && songs.data" :key="d.id">
                        <td
                          class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6"
                        >
                          {{ i + 1 }}.
                        </td>
                        <td
                          class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6"
                        >
                          <div class="flex items-center">
                            <div
                              class="h-12 w-12 flex-shrink-0 flex relative justify-center items-center"
                              v-if="
                                getRelationships(
                                  d &&
                                    d.relationships &&
                                    d.relationships.artists &&
                                    d.relationships.artists.data,
                                  songs && songs.included
                                )[0].attributes.image
                              "
                            >
                              <img
                                class="h-12 w-12 rounded-md"
                                :src="
                                  getRelationships(
                                    d &&
                                      d.relationships &&
                                      d.relationships.artists &&
                                      d.relationships.artists.data,
                                    songs && songs.included
                                  )[0].attributes.image
                                "
                                alt=""
                                @error="defaultImage"
                              />
                              <button
                                class="absolute text-green-dark focus:outline-none hidden play-icon"
                                title="Play"
                                @click="onclickPlay(d && d.id)"
                                :class="`play-${d && d.id}`"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="25.5"
                                  height="25.5"
                                  viewBox="0 0 25.5 25.5"
                                >
                                  <g
                                    id="Icon_feather-play-circle"
                                    data-name="Icon feather-play-circle"
                                    transform="translate(-2.25 -2.25)"
                                  >
                                    <path
                                      id="Path_2385"
                                      data-name="Path 2385"
                                      d="M27,15A12,12,0,1,1,15,3,12,12,0,0,1,27,15Z"
                                      transform="translate(0 0)"
                                      fill="#8dc73f"
                                      stroke="#8dc73f"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="1.5"
                                    />
                                    <path
                                      id="Path_2386"
                                      data-name="Path 2386"
                                      d="M15,12l9,6-9,6Z"
                                      transform="translate(-3.429 -3)"
                                      fill="#fff"
                                      stroke="#fff"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="1.5"
                                    />
                                  </g>
                                </svg>
                              </button>
                              <button
                                class="absolute text-green-dark focus:outline-none hidden pause-icon"
                                title="Pause"
                                @click="onclickPause(d && d.id)"
                                :class="`pause-${d && d.id}`"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  class="h-8 w-8"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                                    clip-rule="evenodd"
                                  />
                                </svg>
                              </button>
                            </div>
                            <div class="h-12 w-12 flex-shrink-0" v-else>
                              <img
                                class="h-12 w-12 rounded-md"
                                src=""
                                alt=""
                                @error="defaultImage"
                              />
                            </div>
                            <div class="ml-4">
                              <div class="font-semibold text-gray-900">
                                {{
                                  (d && d.attributes && d.attributes.title) ||
                                  "Music Name"
                                }}
                              </div>
                              <div class="text-gray-dark">
                                {{
                                  getRelationships(
                                    d &&
                                      d.relationships &&
                                      d.relationships.artists &&
                                      d.relationships.artists.data,
                                    songs && songs.included
                                  )[0].attributes.name || "Artist Name"
                                }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          <button
                            class="focus:outline-none"
                            @click="onclickWaveform(d && d.id)"
                          >
                            <av-waveform
                              :audio-class="`audio-${d && d.id}`"
                              :audio-src="
                                getRelationships(
                                  d &&
                                    d.relationships &&
                                    d.relationships.audio_files &&
                                    d.relationships.audio_files.data,
                                  songs && songs.included
                                )[0].attributes.versions.mp3
                              "
                              :canv-width="250"
                              :canv-height="30"
                              :audio-controls="false"
                              :playtime-with-ms="false"
                              :playtime-clickable="true"
                              :played-line-color="'#8dc73f'"
                              :noplayed-line-color="'#B5B5B5'"
                              :playtime-font-color="'#8dc73f'"
                              :playtime-slider-color="'#8dc73f'"
                              :played-line-width="0.8"
                              :noplayed-line-width="1"
                            >
                            </av-waveform>
                          </button>
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          <!-- <div class="text-gray-900">Front-end Developer</div> -->
                          <!-- <div class="text-gray-500">Optimization</div> -->
                          {{
                            formatSecond(
                              getRelationships(
                                d &&
                                  d.relationships &&
                                  d.relationships.audio_files &&
                                  d.relationships.audio_files.data,
                                songs && songs.included
                              )[0].attributes.duration || "0.00" / 60
                            )
                          }}
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          {{
                            d &&
                            d.attributes &&
                            d.attributes.tags &&
                            d.attributes.tags.mood &&
                            d.attributes.tags.mood.toString()
                          }}
                        </td>
                        <td class="whitespace-nowrap px-3 py-4 text-gray-dark">
                          <button
                            @click="onClickFavorite(0, d, d && d.id)"
                            v-if="checkIfFavorite(d && d.id)"
                            class="focus:outline-none"
                          >
                            <HeartFill :classStr="'h-8 w-8'" />
                          </button>
                          <button
                            @click="onClickFavorite(1, d, d && d.id)"
                            v-else
                            class="focus:outline-none"
                          >
                            <Heart :classStr="'h-8 w-8'" />
                          </button>
                        </td>
                        <td
                          class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
                        >
                          <button
                            type="button"
                            title="Add"
                            class="hover:bg-green-light hover:text-white focus:outline-none"
                            @click="
                              onclickAdd(
                                d.id,
                                d && d.attributes && d.attributes.title,
                                d &&
                                  d.relationships &&
                                  d.relationships.artists &&
                                  d.relationships.artists.data,
                                d &&
                                  d.relationships &&
                                  d.relationships.audio_files &&
                                  d.relationships.audio_files.data,
                                d &&
                                  d.attributes &&
                                  d.attributes.tags &&
                                  d.attributes.tags.mood &&
                                  d.attributes.tags.mood
                              )
                            "
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6 ring-2 ring-green-light rounded-md"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              stroke-width="2"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <p>No data found.</p>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-8">
          <button
            class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light"
            @click="onclickViewmore"
            v-if="songs && songs.links && songs.links.next"
          >
            View More
          </button>
        </div>
      </section>

      <!-- Explore Music -->
      <section class="mb-4" v-else>
        <!-- <h3
            class="font-medium leading-tight text-xl mt-0 mb-4 text-gray-dark"
          >
          </h3> -->
        <ul
          role="list"
          class="grid gap-8 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 3xl:grid-cols-6"
          v-if="artists"
        >
          <li v-for="a in artists" :key="a.id">
            <router-link
              :to="{
                name: 'music',
                params: { cat: a && a.attributes && a.attributes.name },
              }"
            >
              <div class="space-y-2">
                <img
                  class="rounded-md object-cover duration-500 shadow-all"
                  :src="
                    a &&
                    a.attributes &&
                    a.attributes.image &&
                    a.attributes.image.slice(0, -12)
                  "
                  alt=""
                />
                <div class="space-y-2">
                  <div class="leading-6 space-y-1">
                    <h3 class="text-sm text-gray-darklabel font-medium">{{ a && a.attributes && a.attributes.name }}</h3>
                    <!-- <a
                        href="#"
                        class="text-gray-light text-sm hover:text-blue-500 hover:underline"
                      >
                        23 Songs
                      </a> -->
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <div class="text-center mt-8">
          <button
            class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light"
            @click="onclickMoreArtists"
            v-if="artists && artists.links && artists.links.next"
          >
            View More
          </button>
        </div>
      </section>
    </section>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import { Plus, X, Heart, HeartFill } from "@/components/icons";
import { Modal } from "@/components/t-components";
import debounce from "debounce";
import MultiRangeSlider from "multi-range-slider-vue";
import { duration } from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Music",
  components: {
    TrainerLayout,
    MultiRangeSlider,
    Modal,
    Plus,
    X,
    Heart,
    HeartFill,
  },
  data() {
    return {
      mood: [],
      genre: [],
      songs: [],
      artists: [],
      moodIds: [],
      genreIds: [],
      energy: 2,
      // energyMinValue: 1,
      // energyMaxValue: 4,
      bpm: 2,
      bpmMinValue: 1,
      bpmMaxValue: 150,
      search: "",
      isMenuOpen: false,
      isPlaylistOpen: false,
      playlistData: {},
      genreArr: [],
      moodArr: [],
      vocals: "All",
      filterValues: [],
      selectedGenre: [],
      selectedMood: [],
      artistName: "",
      showMoreGenre: false,
      showMoreMood: false,
      isFavorite: false,
      favoriteArr: [],
      favoriteData: [],
      lastPage: null,
      playlistSong: null,
      songName: "",
      songImage: "",
      songArtist: ""
    };
  },
  computed: {
    ...mapGetters(["trainerPlaylist", "trainerFavoriteSong", "favoriteList"]),
  },
  methods: {
    ...mapActions([
      "getTrainerPlaylist",
      "postTrainerPlaylistSong",
      "getTrainerFavoriteSong",
      "postTrainerFavoriteSong",
      "getUpdateFavoriteList",
    ]),

    listMood() {
      fetch(`https://api.soundstripe.com/v1/tags?filter[category]=mood`, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) this.mood = data && data.data;
        })
        .catch((e) => console.log(e));
    },
    checkIfFavorite(id) {
      return this.favoriteList.includes(id);
    },
    async onClickFavorite(val, data, id) {
      var sort;
      this.onclickFavSong(
        data.id,
        data && data.attributes && data.attributes.title,
        data &&
          data.relationships &&
          data.relationships.artists &&
          data.relationships.artists.data,
        data &&
          data.relationships &&
          data.relationships.audio_files &&
          data.relationships.audio_files.data,
        data &&
          data.attributes &&
          data.attributes.tags &&
          data.attributes.tags.mood &&
          data.attributes.tags.mood,
        val === 0 ? "no" : "yes",
        (sort = 0)
      );
      await this.postTrainerFavoriteSong(this.favoriteData);
      this.favoriteArr = [];
      this.loadFavorite();
    },
    async loadFavorite() {
      await this.getTrainerFavoriteSong(1);
      this.lastPage =
        this.trainerFavoriteSong &&
        this.trainerFavoriteSong.data &&
        this.trainerFavoriteSong.data.last_page;
      var start = 1;
      while (start <= this.lastPage) {
        await this.getTrainerFavoriteSong(start);
        this.trainerFavoriteSong &&
          this.trainerFavoriteSong.data &&
          this.trainerFavoriteSong.data.data.forEach((item) => {
            this.favoriteArr.push(item.song_id.toString());
          });
        start++;
      }
      await this.getUpdateFavoriteList(this.favoriteArr);
    },
    onclickFavSong(id, title, artists, audio_files, mood, val, sort) {
      const data = {
        id: 1,
        song_id: id,
        image: this.getRelationships(
          artists,
          this.songs && this.songs.included
        )[0].attributes.image,
        name: title,
        artist: this.getRelationships(
          artists,
          this.songs && this.songs.included
        )[0].attributes.name,
        url: this.getRelationships(
          audio_files,
          this.songs && this.songs.included
        )[0].attributes.versions.mp3,
        duration: this.getRelationships(
          audio_files,
          this.songs && this.songs.included
        )[0].attributes.duration,
        mood: JSON.stringify(mood),
        favourite: val,
        sort: sort,
      };

      this.favoriteData = data;
    },

    onclickGenre(g) {
      var index = this.selectedGenre.findIndex((el) => el.id == g.id);
      if (index === -1) {
        this.selectedGenre.push(g);
        this.genre.splice(
          this.genre.findIndex((item) => item.id === g.id),
          1
        );
      } else {
        this.selectedGenre.splice(
          this.selectedGenre.findIndex((item) => item.id === g.id),
          1
        );
        this.genre.push(g);
      }
    },

    onclickMood(m) {
      var index = this.selectedMood.findIndex((el) => el.id == m.id);
      if (index === -1) {
        this.selectedMood.push(m);
        this.mood.splice(
          this.mood.findIndex((item) => item.id === m.id),
          1
        );
      } else {
        this.selectedMood.splice(
          this.selectedMood.findIndex((item) => item.id === m.id),
          1
        );
        this.mood.push(m);
      }
    },

    listGenre() {
      fetch(`https://api.soundstripe.com/v1/tags?filter[category]=genre`, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) this.genre = data && data.data;
          this.genre.links = data && data.links;
          this.listGenreMore(this.genre.links.next);
          this.listGenreMore(this.genre.links.last);
        })
        .catch((e) => console.log(e));
    },

    listGenreMore(url) {
      fetch(url, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            var moreGenre = data && data.data;
            this.genre.push(...moreGenre);
          }
        })
        .catch((e) => console.log(e));
    },

    listArtists() {
      var songsURL = "https://api.soundstripe.com/v1/songs?page[size]=23";
      if (
        this.$route.params &&
        this.$route.params.cat &&
        this.$route.params &&
        this.$route.params.cat != "All Music"
      ) {
        songsURL = `https://api.soundstripe.com/v1/songs?filter[q]=${
          this.$route.params && this.$route.params.cat
        }`;
      }
      fetch(songsURL, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          // this.artists = data;
          var arr = [];
          data &&
            data.included.forEach((el, i) => {
              if (el.type == "artists") {
                arr.push(el);
              }
            });
          this.artists = arr.slice(0, 10);
          this.artists.links = data.links;
        })
        .catch((e) => console.log(e));
    },

    listSongs() {
      var songsURL = "https://api.soundstripe.com/v1/songs";
      if (
        this.$route.params &&
        this.$route.params.cat &&
        this.$route.params &&
        this.$route.params.cat != "All Music"
      ) {
        songsURL = `https://api.soundstripe.com/v1/songs?filter[q]=${
          this.$route.params && this.$route.params.cat
        }`;
        this.artistName = this.$route.params && this.$route.params.cat;
      }
      fetch(songsURL, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => (this.songs = data))
        .catch((e) => console.log(e));
    },

    oninputSearch: debounce(async function () {
      fetch(`https://api.soundstripe.com/v1/songs?filter[q]=${this.search}`, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) this.songs = data;
        })
        .catch((e) => console.log(e));
    }, 1000),

    getRelationships(result1, result2) {
      var result = result2.filter(function (o1) {
        return (
          result1 &&
          result1.some(function (o2) {
            return o1.id === o2.id; // return the ones with equal id
          })
        );
      });
      return result;
    },

    onclickWaveform(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "none";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "block";

      var allAudios = document.querySelectorAll("audio");
      allAudios.forEach(function (audio) {
        audio.pause();
      });
      allAudios.forEach(function (audio) {
        audio.currentTime;
        if (audio.className != `audio-${id}`) {
          audio.load();
          audio.currentTime = 0;
          audio.closest("tr").classList.remove("active");
        } else {
          audio.play();
          audio.closest("tr").classList.add("active");
        }
      });
    },

    onclickPlay(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "none";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "block";

      var allAudios = document.querySelectorAll("audio");
      allAudios.forEach(function (audio) {
        audio.pause();
      });
      allAudios.forEach(function (audio) {
        audio.currentTime = 0;
        if (audio.className != `audio-${id}`) {
          audio.load();
          audio.currentTime = 0;
          audio.closest("tr").classList.remove("active");
        } else {
          audio.play();
          audio.closest("tr").classList.add("active");
        }
      });
    },

    onclickPause(id) {
      var elems = document.getElementsByClassName("play-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var elems = document.getElementsByClassName("pause-icon");
      for (var i = 0, len = elems.length; i < len; i++) {
        elems[i].style.display = "none";
      }

      var playIcon = document.getElementsByClassName(`play-${id}`)[0];
      playIcon.style.display = "block";

      var pauseIcon = document.getElementsByClassName(`pause-${id}`)[0];
      pauseIcon.style.display = "none";

      var audio = document.getElementsByClassName(`audio-${id}`)[0];
      audio.pause();
    },

    formatSecond(val) {
      var date = new Date(0);
      date.setSeconds(val); // specify value for SECONDS here
      var timeString = date.toISOString().substr(11, 8);
      return timeString;
    },

    toggleFilterModal() {
      this.isMenuOpen = !this.isMenuOpen;
      this.showMoreGenre = false;
      this.showMoreMood = false;
    },

    onclickClear() {
      // this.moodIds = [];
      // this.genreIds = [];
      // (this.selectedMood = []),
      //   (this.selectedGenre = []),
      (this.energy = ""), (this.vocals = ""), (this.bpmMinValue = 1);
      this.bpmMaxValue = 150;
      this.selectedGenre.forEach((element) => {
        this.genre.push(element);
      });
      this.selectedGenre.length = 0;

      this.selectedMood.forEach((element) => {
        this.mood.push(element);
      });
      this.selectedMood.length = 0;
    },

    onclickApply() {
      this.moodIds = this.selectedMood.map((item) => {
        return item.id;
      });
      this.genreIds = this.selectedGenre.map((item) => {
        return item.id;
      });
      if (this.artistName !== "") {
        var url = `https://api.soundstripe.com/v1/tags`;
      }
      if (this.moodIds.length !== 0) {
        var url = `?filter[tags][mood]=${this.moodIds}`;
        this.filterFetch(url);
      }

      if (this.genreIds.length !== 0) {
        var url = `?filter[tags][genre]=${this.genreIds}`;
        this.filterFetch(url);
      }

      if (this.energy) {
        var energyArr = ["very_low", "low", "medium", "high"];
        var url = `?filter[energy]=${energyArr[this.energy - 1]}`;
        this.filterFetch(url);
      }

      var vocals = document.querySelector('input[name="vocals"]:checked');
      if (vocals && vocals.value == "vocals") {
        var url = `?filter[vocals]=true`;
        this.filterFetch(url);
      }
      if (vocals && vocals.value == "instrumental") {
        var url = `?filter[instrumental]=true`;
        this.filterFetch(url);
      }

      if (this.bpmMinValue) {
        var url = `?filter[bpm][max]=${this.bpmMaxValue}`;
        this.filterFetch(url);
      }
      if (this.bpmMaxValue) {
        var url = `?filter[bpm][min]=${this.bpmMinValue}`;
        this.filterFetch(url);
      }
      this.toggleFilterModal();
    },

    filterFetch(categoryUrl) {
      var url = "https://api.soundstripe.com/v1/songs" + categoryUrl;
      fetch(url, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => (this.songs = data))
        .catch((e) => console.log(e));
    },

    onclickAdd(id, title, artists, audio_files, mood) {
      const data = {
        id: 1,
        song_id: id,
        image: this.getRelationships(
          artists,
          this.songs && this.songs.included
        )[0].attributes.image,
        name: title,
        artist: this.getRelationships(
          artists,
          this.songs && this.songs.included
        )[0].attributes.name,
        url: this.getRelationships(
          audio_files,
          this.songs && this.songs.included
        )[0].attributes.versions.mp3,
        duration: this.getRelationships(
          audio_files,
          this.songs && this.songs.included
        )[0].attributes.duration,
        mood: JSON.stringify(mood),
        sort: 1,
      };
      (this.songImage = data.image),
        (this.songName = data.name),
        (this.songArtist = data.artist),
        (this.playlistData = data),
      this.togglePlaylistModal();
    },

    async onClickPlaylist(id) {
      var data = this.playlistData;
      data.playlist_id = id;
      await this.postTrainerPlaylistSong(data);
      this.getTrainerPlaylist();
      this.togglePlaylistModal();
    },

    togglePlaylistModal() {
      this.isPlaylistOpen = !this.isPlaylistOpen;
    },

    onclickViewmore() {
      var songsURL = this.songs && this.songs.links && this.songs.links.next;

      fetch(songsURL, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          data &&
            data.data.forEach((el) => {
              this.songs.data.push(el);
            });
          data &&
            data.included.forEach((el) => {
              this.songs.included.push(el);
            });
          this.songs.links = data.links;
        })
        .catch((e) => console.log(e));
    },

    onclickMoreArtists() {
      var artistsURL =
        this.artists && this.artists.links && this.artists.links.next;

      fetch(artistsURL, {
        method: "GET",
        headers: {
          Authorization:
            "Token hBDP7N6hdi4x1WDbDgapZRjWb1h75vy2Y0941kCO9doSex5Rvm6J62vK4TyknEgo",
          "Content-Type": "application/vnd.api+json",
          Accept: "application/vnd.api+json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          // data &&
          //   data.data.forEach((el) => {
          //     this.artists.data.push(el);
          //   });
          var arr = [];
          data &&
            data.included.forEach((el, i) => {
              if (el.type == "artists") {
                var index = this.artists.findIndex((x) => x.id == el.id);
                if (index === -1) {
                  arr.push(el);
                } else {
                  console.log("object already exists");
                }
              }
            });
          arr.slice(0, 10).forEach((el) => {
            this.artists.push(el);
          });
          this.artists.links = data.links;
        })
        .catch((e) => console.log(e));
    },

    // UpdateEnergyValues(e) {
    // this.energyMinValue = e.minValue;
    // this.energyMaxValue = e.maxValue;
    // },

    UpdateBpmValues(e) {
      this.bpmMinValue = e.minValue;
      this.bpmMaxValue = e.maxValue;
    },
  },
  async mounted() {
    this.listArtists();
    this.listSongs();
    this.listMood();
    this.listGenre();
    this.getTrainerPlaylist();
  },
  async created() {
    await this.getTrainerFavoriteSong(1);
    this.loadFavorite();
  },
};
</script>

<style scoped>
.play-icon {
  display: none;
}
tr:not(.active):hover .play-icon {
  display: inline !important;
}
tr:hover td {
  background: #f5f5f5;
}

::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-thumb {
  background: #707070;
  border-radius: 6px;
}
</style>
<style>
.multi-range-slider {
  border: none;
  box-shadow: none;
  padding: 14px 14px;
}

.multi-range-slider .bar-left {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 0px #8dc73f;
}

.multi-range-slider .bar-left::after {
  background-color: #8dc73f;
}

.multi-range-slider .bar-inner {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 1px #8dc73f;
  background-color: #8dc73f;
}

.multi-range-slider .bar-right {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 0px #8dc73f;
}

.multi-range-slider .thumb::before {
  box-shadow: none;
  -webkit-box-shadow: none;
  border: solid 1px #8dc73f;
  background-color: #8dc73f;
}

.multi-range-slider .thumb .caption * {
  background-color: #8dc73f;
}
.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 3px;
  border-radius: 5px;
  background: #8dc73f;
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #8dc73f;
  cursor: pointer;
}
.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #8dc73f;
  cursor: pointer;
}
</style>
